<template>
    <div class="vue timparty-cards-specifications cards-specifications bg-dark">
      <div class="container">
       
        <section class="cards-content">
          <div class="row">
            <div class="col-md-3">
              <ul class="cards-index">
                <li class="pb-4 pr-4"  v-for="(section,idx) in component_data" v-bind:key="idx">
                  <a :href="'#panel-' + idx" data-toggle="collapse" role="button" aria-expanded="false" :aria-controls="'panel-' + idx" :class=" idx == 0 ? '' : 'collapsed'">{{ section.title }}</a>
                </li>
              </ul>
            </div>
            <div class="col-md-9">
              <div v-if="component_data.length > 0" class="panels-container" id="panels-container">
                <div v-for="(section,idx) in component_data" v-bind:key="idx" :class="'card-panel collapse p-3 ' + (idx == 0 ? 'show' : '' ) " :id="'panel-' + idx" data-parent="#panels-container">
                  <div class="row">
                    
                    <div :class="getColumnsClass(section)" v-for="(chunk, kidx) in makeCardsChunks(section)" v-bind:key="kidx">
                      <div v-for="(card, cidx) in chunk"  v-bind:key="cidx" class="card-item mb-4">
                        <h5 class="title" v-if="card.title">{{ card.title }}</h5>
                        <h6 class="summary" v-if="card.subtitle">{{ card.subtitle }}</h6>
                        <div class="description" v-html="card.description"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </section>
      </div>
    </div>
</template>

<script>

    /* eslint-disable */ 

    import TimPartyMixin from '../mixins/TimPartyMixin';
    import _ from 'lodash';

    export default {
      name: 'CardsSpecifications',
      mixins: [ TimPartyMixin ],
      props: {
        hideNumbers: {
          type: Boolean,
          required: false,
          default: false,
        },
        data: {
          type: Object,
          required: true,
        },
       
      },
      data: function(){

        return {
          component_data: {},
        };
      },
      mounted: function(){

        if(this.data)
          this.component_data = this.data;

         
      
      },
      
      methods: {
        makeCardsChunks: function( section, chunks){

          var items = section.cards;

          if( section.theme == 'SINGLE_COLUMN' ) chunks = 1;
          else if( chunks == undefined) chunks = 2;

          var items_per_chunk = Math.ceil( items.length / chunks );
          
          return _.chunk(items, items_per_chunk);

        },
        getColumnsClass: function( section ){

          if( section.theme == 'SINGLE_COLUMN' )
            return 'col-sm-12';


          return 'col-sm-6';

        },
      },
      computed: {
        
      }
    }
  </script>


